import { Component, OnInit } from '@angular/core';
import * as firebase from 'firebase/app';
import { Router, ActivatedRoute, ActivationEnd, NavigationEnd } from '@angular/router';
import { ToggleService } from '../../services/toggle/toggle.service';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection, docChanges } from 'angularfire2/firestore';
import { Observable, Subject, Notification } from 'rxjs/Rx';
import { Institution } from '../../modules/datamodel/institution';
import { User } from '../../modules/datamodel/user';
import { AuthService } from '../../services/auth/auth.service';
import { StateService } from '../../services/state/state.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { of } from 'rxjs/observable/of';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    public user: object;
    public userId: string;
    public loggedInUser: object;
    public selectedInstitution: Institution;
    public disabled = false;
    public breadcrumbPage: Observable<string>;
    menu_toggle: Boolean = false;
    private userRef: AngularFirestoreCollection<User>;
    obsUser: Observable<any>;
    routes:any[]=[];
    activeNotifications = 0;
    public status: {
        isopen: boolean
    } = {
            isopen: false
        };
    
    hospName: string;

    constructor(private afs: AngularFirestore, public afAuth: AngularFireAuth, public auth: AuthService, private state: StateService, public router: Router, public toggle: ToggleService, protected storage: LocalStorageService, public route: ActivatedRoute) {
        this.auth
            .user
            .subscribe(user => {
                this.user = user;
                this.userId = this.afAuth.auth.currentUser.uid;
                console.log(this.userId);
                if (user && user.adminFor.length > 0) {
                    this.hospName = user.adminFor[0].name;
                }else{
                    this.hospName = "Hospital";
                }
            });
        
        state
            .selectedInstitution
            .subscribe(si => {
                this.selectedInstitution = si;
                console.log(this.selectedInstitution);
            });
        
        this.getActiveNotifications();    
         
        this.router.events
            .filter((event) => event instanceof NavigationEnd)
            .map(() => this.route)
            .map((route) => {
                while (route.firstChild) route = route.firstChild;
                return route;
            })
            .filter((route) => route.outlet === 'primary')
            .mergeMap((route) => route.data)
            .subscribe((event) => {
                this.breadcrumbPage = of(event.title);
            });

        this.setRoutes(router.url);   

    }

    setRoutes(url){
        console.log(url);
        switch(url){
            case '/doctors' : 
                this.routes = [
                    { link: '/', label: 'Home', data: { title: 'Home' } },
                    { link : '/doctors', label : 'Providers', data: { title: 'Providers' }}
                ]
                break;

            case '/add-doctor':
                this.routes = [
                    { link: '/', label: 'home', data: { title: 'home' } },
                    { link: '/doctors', label: 'Providers', data: { title: 'Providers' } },
                    { link: '/add-doctor', label: 'Add Provider', data: { title: 'Add Provider' } }
                ]
                break;

            case '/add-doctor/:id':
                this.routes = [
                    { link: '/', label: 'home', data: { title: 'home' } },
                    { link: '/doctors', label: 'Providers', data: { title: 'Providers' } },
                    { link: '', label: 'Edit Provider', data: { title: 'Edit Provider' } }
                ]
                break;

            case '/schedules':
                this.routes = [
                    { link: '/', label: 'Home', data: { title: 'Home' } },
                    { link: '/schedules', label: 'Schedules', data: { title: 'Schedules' } }
                ]
                break;
                
            case '/add-schedule':
                this.routes = [
                    { link: '/', label: 'home', data: { title: 'home' } },
                    { link: '/schedules', label: 'Schedules', data: { title: 'Schedules' } },
                    { link: '/add-doctor', label: 'Add Schedule', data: { title: 'Add Schedule' } }
                ]
                break;

            case '/edit-schedule/:id':
                this.routes = [
                    { link: '/', label: 'home', data: { title: 'home' } },
                    { link: '/schedules', label: 'Schedules', data: { title: 'Schedules' } },
                    { link: '', label: 'Edit Schedule', data: { title: 'Edit Schedule' } }
                ]
                break;
        }
    }

    setInstitution(value) {
        console.log(value);
        this
            .state
            .setSelectedInstitutionPath(value);
    }

    ngOnInit() {
        this.loggedInUser = this.auth.validateAuthUser();
        console.log(this.loggedInUser);
    }

    public toggled(open: boolean): void {
        console.log('Dropdown is now: ', open);
    }

    public menuToggle($event: MouseEvent): void {
        $event.preventDefault();
        $event.stopPropagation();
        this.menu_toggle = !this.menu_toggle;
    }

    public toggleDropdown($event: MouseEvent): void {
        $event.preventDefault();
        $event.stopPropagation();
        this.status.isopen = !this.status.isopen;
    }

    getActiveNotifications(){
        this.afs.collection('notifications', ref => ref.where('shift_request_status','==','accepted')).valueChanges().flatMap(res => {
            return this.afs.collection('notifications', ref => ref.where('swap_status','==','accepted')).valueChanges().map( res1 => res1.concat(res))
        })
        .subscribe(res => {
            this.activeNotifications = res.length;
        })
    }



    public logout() {
        console.log('logging out');
        this
            .auth
            .logout();
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/header/header.component.ts